// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-input[data-v-bf2c335a] {\n  width: 300px;\n}", ""]);
// Exports
module.exports = exports;
